import { render, staticRenderFns } from "./FileImportWaste.vue?vue&type=template&id=2df4abc5&"
import script from "./FileImportWaste.vue?vue&type=script&lang=js&"
export * from "./FileImportWaste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports